import {
    selectImageColorFinderFlights,
    selectNonArchivedOrthoFlights,
} from "features/entity-caching/flights/selectors"
import { selectNonArchivedLines } from "features/entity-caching/lines/selectors"
import {
    selectMergedFlights,
    selectUnmergedNonArchivedInfraredFlights,
} from "features/entity-caching/mergedFlights/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useMemo } from "react"

export const useFirePerimeterAutoCategories = ({ searchContents }: { searchContents: string }) => {
    const rawHotspotFlights = useAppSelector(selectUnmergedNonArchivedInfraredFlights)
    const rawMergedFlights = useAppSelector(selectMergedFlights)
    const orthoFlights = useAppSelector(selectNonArchivedOrthoFlights)
    const colorFinderFlights = useAppSelector(selectImageColorFinderFlights)
    const rawLines = useAppSelector(selectNonArchivedLines)

    const hotspotFlights = useMemo(
        () =>
            rawHotspotFlights
                .filter((flight) => {
                    if (!searchContents) return true

                    const lowerCaseSearch = searchContents.toLowerCase()
                    return flight.name.toLowerCase().includes(lowerCaseSearch)
                })
                .map((flight) => {
                    if (flight.hotspots.length < 3)
                        return {
                            ...flight,
                            errorMessage:
                                "Hotspot layers must contain at\nleast three hotspots to reference.",
                        }
                    return flight
                }),
        [rawHotspotFlights, searchContents]
    )

    const mergedFlights = useMemo(
        () =>
            rawMergedFlights
                .filter((flight) => {
                    if (!searchContents) return true

                    const lowerCaseSearch = searchContents.toLowerCase()
                    return flight.name.toLowerCase().includes(lowerCaseSearch)
                })
                .map((flight) => {
                    if (flight.hotspots.length < 3)
                        return {
                            ...flight,
                            errorMessage:
                                "Hotspot layers must contain at\nleast three hotspots to reference.",
                        }
                    return flight
                }),
        [searchContents, rawMergedFlights]
    )

    const flightsWithFlightPaths = useMemo(
        () =>
            [...rawHotspotFlights, ...orthoFlights, ...colorFinderFlights].filter((flight) => {
                if (!searchContents) return true

                const lowerCaseSearch = searchContents.toLowerCase()
                return flight.name.toLowerCase().includes(lowerCaseSearch)
            }),
        [rawHotspotFlights, orthoFlights, colorFinderFlights, searchContents]
    )

    const lines = useMemo(
        () =>
            rawLines.filter((line) => {
                if (!searchContents) return true

                const lowerCaseSearch = searchContents.toLowerCase()
                return line.name.toLowerCase().includes(lowerCaseSearch)
            }),
        [rawLines, searchContents]
    )

    return { hotspotFlights, flightsWithFlightPaths, lines, mergedFlights }
}
